var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSound = function SvgSound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.92 5.1-4 3.06H5.1A1.09 1.09 0 0 0 4 9.24v5.52a1.08 1.08 0 0 0 1.09 1.07h2.8l4 3.07a.5.5 0 0 0 .8-.4v-13a.5.5 0 0 0-.77-.4ZM15.66 8.83l-.61-.58-1.21 1.2.61.59a2.48 2.48 0 0 1 0 3.63l-.61.59 1.21 1.21.61-.59a4.15 4.15 0 0 0 0-6.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.65 6.42 17 5.83 15.82 7l.62.59a5.8 5.8 0 0 1 0 8.46l-.62.6L17 17.89l.62-.59a7.49 7.49 0 0 0 0-10.88Z"
  }))));
};
export default SvgSound;